 // Section with Editor
    $(document).on('shopify:section:load', function(e){ 
      $('#' + e.target.id).find('[data-section]').sectionJs();
    }).ready(function() {
      $('[data-section]').each(function(){ $(this).sectionJs() });
    });

  $.fn.sectionJs = function(){
    var $this = this;
    if($this.data('section') == "headerscript") {
      $this.headerscript();
    }else if($this.data('section') == "SliderOne") {
      $this.find('.ht-hero-slider').sliderone();
    }else if($this.data('section') == "foodcategory") {
      $this.find('.ht-food-slider').foodcategory();
    }else if($this.data('section') == "tabproductwithcarosle") {
      $this.find('.product-carousel').tabproductwithcarosle();
    }else if($this.data('section') == "randomproduct") {
      $this.find('.feaured-carousel').randomproduct();
    }else if($this.data('section') == "latestblog") {
      $this.find('.blog-carousel').latestblog();
    }else if($this.data('section') == "dailydealproduct") {
      $this.find('.timer-carousel').dailydealproduct();
    }else if($this.data('section') == "productWithCarousel") {
      $this.find('.product-carousel-two').productWithCarousel();
    }else if($this.data('section') == "testimonial") {
      $this.find('.text-carousel').testimonialtext();
      $this.find('.image-carousel').testimonialimag();
    }else if($this.data('section') == "BrandLogo") {
      $this.find('.our-brand-active').BrandLogo();
    }else{}   
  }
  

  /*============== Header ==================*/
  $.fn.headerscript = function() {
  $('.mega-menu-title').parent('ul').addClass('ht-mega-menu');
  $('.submenu-li').parent('ul').addClass('sub-menu');
  };



  /*==============All Slick Slider ==================*/
  
  	/* slider One */
    $.fn.sliderone = function() {
      var heroSlider = this;
      heroSlider.slick({
        arrows: true,
		prevArrow:"<button type='button' class='slick-prev'><i class='fa fa-angle-left'></i></button>",
		nextArrow:"<button type='button' class='slick-next'><i class='fa fa-angle-right'></i></button>",
		autoplaySpeed: 3000,
		dots: true,
		pauseOnFocus: false,
		pauseOnHover: false,
		infinite: true,
		slidesToShow: 1
      });
      heroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var sliderTitle = $('.ht-hero-slider h1');
        var currentTitle = $('.slick-current h1');
        sliderTitle.removeClass('cssanimation leDoorCloseLeft sequence');
        currentTitle.addClass('cssanimation leDoorCloseLeft sequence');
      });
      heroSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        var sliderTitle = $('.ht-hero-slider h1');
        var currentTitle = $('.slick-current h1');
        sliderTitle.removeClass('cssanimation leDoorCloseLeft sequence');
        currentTitle.addClass('cssanimation leDoorCloseLeft sequence');
      });
    };
  
    
    /* Food Category */
    $.fn.foodcategory = function() {
      var $FoodCategoryVAR = this;
      $FoodCategoryVAR.slick({
        infinite: true,
		arrows: false
      });
    };
  
    /* product Carousle With Tab */
    $.fn.tabproductwithcarosle = function() {
      var $tabproductwithcarosleVAR = this;
      $tabproductwithcarosleVAR.slick({
        arrows: true,
		infinite: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      });
    };
  
    /* Random Product */
    $.fn.randomproduct = function() {
      var $randomproductVAR = this;
      $randomproductVAR.slick({
        arrows: true,
		autoplay: false,
		infinite: true,
		slidesToScoll: 1,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      });
    };

	
    
    /* Blog Carousle */
    $.fn.latestblog = function() {
      var $latestblogVAR = this;
      $latestblogVAR.slick({
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      });
    };
    
    /* Daily Deals Product */
    $.fn.dailydealproduct = function() {
      var $dailydealproductVAR = this;
      $dailydealproductVAR.slick({
        arrows: true,
        infinite: true,                
        centerMode: true,
        centerPadding: '0',
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>'
      });
      
      /*------------------------------------
		Countdown
		--------------------------------------*/	
      $('[data-countdown]').each(function() {
        var $this = $(this), finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
          $this.html(event.strftime('<div class="cdown"><span class="counting">%-D</span>days</div><div class="cdown"><span class="counting">%-H</span>hours</div><div class="cdown"><span class="counting">%M</span>mins</div><div class="cdown"><span class="counting">%S</span>secs</div>'));
        });
      });
      
    };
    
  /* Product With Carousle */
  $.fn.productWithCarousel = function() {
    var $productWithCarouselVAR = this;
    $productWithCarouselVAR.slick({
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    });
  };



  /* Testimonial */
    $.fn.testimonialtext = function() {
      var $testimonialtextVAR = this;
      $testimonialtextVAR.slick({
        slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
		asNavFor: '.image-carousel',
      });
    };

    /* Testimonial */
    $.fn.testimonialimag = function() {
      var $testimonialimagVAR = this;
      $testimonialimagVAR.slick({
        slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.text-carousel',
		arrows: false,
		dots: false,
		centerMode: true,
		focusOnSelect: true
      });
    };

	/* Brand Logo */
    $.fn.BrandLogo = function() {
      var $BrandLogoVAR = this;
      $BrandLogoVAR.slick({
        "infinite": true,
      });
    };





(function($) {
  "use strict";

  jQuery(document).ready(function(){


	/*---------------------------------
	Search slideToggle
	-----------------------------------*/
	$(".search-wrapper > a").on("click", function() {
		$('.search-form').toggleClass('active');
	}); 

	/*---------------------------------
	Setting slideToggle
	-----------------------------------*/
	$(".settings-wrapper > a").on("click", function() {
		$('.settings-content').toggleClass('active');
	}); 


	/*---------------------------------
	Menu Sticky
	-----------------------------------*/
	var $windows = $(window);
	var sticky = $('.header-sticky');
	$windows.on('scroll', function() {
		var scroll = $windows.scrollTop();
		if (scroll < 300) {
			sticky.removeClass('sticky');
		}else{
			sticky.addClass('sticky');
		}
	});

	/*------------------------------------
	Mobile Menu
	--------------------------------------*/
	$('#mobile-menu-active').meanmenu({
		meanScreenWidth: "991",
		meanMenuContainer: ".mobile-menu-area .mobile-menu",
	}); 

    
    $('#mobile-menu-active-2').meanmenu({
		meanScreenWidth: "1920",
		meanMenuContainer: ".mobile-menu-area.header-style-five .mobile-menu",
	});
	

	/*--------------------------------------
	Modal Slick Slider
	-----------------------------------------*/
	$('.single-slide-menu').slick({
		dots: false,
		arrows: false,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			}
		]
	});
	$('.modal').on('shown.bs.modal', function (e) {
		$('.single-slide-menu').resize();
	})
	$('.single-slide-menu a').on('click',function(e){
		e.preventDefault();
		var $href = $(this).attr('href');
		$('.single-slide-menu a').removeClass('active');
		$(this).addClass('active');
		$('.product-details-large .tab-pane').removeClass('active show');
		$('.product-details-large '+ $href ).addClass('active show');
	});

	/*------------------------------------
	Scroll Up
	--------------------------------------*/
	$.scrollUp({
		scrollText: '<i class="fa fa-angle-up"></i>',
		easingType: 'linear',
		scrollSpeed: 900,
		animation: 'fade'
	}); 

		

	/*-------------------------------------
	Price Slider
	---------------------------------------*/  
	$( "#slider-range" ).slider({
		range: true,
		min: 55,
		max: 1000,
		values: [ 55, 1000 ],
		slide: function( event, ui ) {
			$( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
		}
	});
	$( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
	   " - $" + $( "#slider-range" ).slider( "values", 1 ) );  

	/*--------------------------------------
	EasyZoom instances
	----------------------------------------*/  
	$('.easyzoom').easyZoom();

	/*---------------------------------------
	Login Toggle
	-----------------------------------------*/
	$( '#showlogin' ).on('click', function() {
		$( '#checkout-login' ).slideToggle(900);
	}); 

	/*----------------------------------------
	Coupon Toggle
	------------------------------------------*/
	$( '#showcoupon' ).on('click', function() {
		$( '#checkout_coupon' ).slideToggle(900);
	});

	/*-----------------------------------------
	Account Toggle
	-------------------------------------------*/
	$( '#cbox' ).on('click', function() {
		$( '#cbox_info' ).slideToggle(900);
	});

	/*-----------------------------------------
	Ship Address Toggle
	--------------------------------------------*/
	$( '#ship-box' ).on('click', function() {
		$( '#ship-box-info' ).slideToggle(1000);
	});	

	/*----------------------------------------
	Scroll Down
	------------------------------------------*/  
	$('.scroll-down').on('click', function() {
		$('html, body').animate({scrollTop: $('.scroll-area').offset().top - 100 }, 'slow');
		return false;
	});
  
      /*--
	MailChimp
	-----------------------------------*/
    $('#mc-form').ajaxChimp({
      language: 'en',
      callback: mailChimpResponse,
      // ADD YOUR MAILCHIMP URL BELOW HERE!
      url: 'http://devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef'

    });
    function mailChimpResponse(resp) {

      if (resp.result === 'success') {
        $('.mailchimp-success').html('' + resp.msg).fadeIn(900);
        $('.mailchimp-error').fadeOut(400);

      } else if(resp.result === 'error') {
        $('.mailchimp-error').html('' + resp.msg).fadeIn(900);
      }  
    }
    
    
    
    
    
    
  
  
  
  

  });
  
})(jQuery);
